
<!-- <router-outlet *ngIf="!isMainHome"></router-outlet>
<app-main-home *ngIf="isMainHome"></app-main-home> -->
<app-header></app-header>
<div style="margin-top: 170px; margin-bottom: 70px;">
<router-outlet></router-outlet>
<app-footer></app-footer>
</div>